const tt = {
  CreativeTasks: {
    TitleTeacher: "Иҗади биремнәр",
    TitleStudent: "Иҗади биремнәр",
    UpdateTaskTeacher: "Сакларга",
    SubmitTaskTeacher: "Нәтиҗәләрне җибәрергә",
    UpdateTaskStudent: "Караламаны сакларга",
    SubmitTaskStudent: "Сакларга һәм тикшерүгә җибәрергә",
    AnswerHeaderStatistics:
      "Сораулар: {{questions}} | Символлар: {{symbols}} | Сүзләр: {{words}} | Җөмләләр: {{sentenses}}",
    QuestionsAndComments: "Хаталар һәм аңлатмалар:",
    HoverForDisplay: "Күрсәтү өчен курсорны күчерегез:",
    CheckingHistory: "Тикшерүләр тарихы",
    CurrentVersion: "Агымдагы версия",
    TeacherComment: "Укытучының эшенә аңлатма:",
    CommentPlaceholder: "Сез монда эш турында аңлатма калдыра аласыз",
    SaveCorrection: "Сакларга",
    CancelCorrection: "Бетерү",
    Grammar: "Грамматика",
    Lexical: "Лексика",
    Comment: "Аңлатма",
    ErrorRangeFilled:
      "Билгеләнгән диапазонда хаталарның барлык төрләре кулланылган",
    SaveError: "Сакларга",
    GrammarErrorTitle: "Грамматика",
    ResultTitle: "Иҗади биремне үтәү нәтиҗәләре",
    Student: "Студент",
    Teacher: "Укытучы",
    CurrentVersionTime: "Агымдагы версия: {{time}}",
    TaskText: "Бирем",
    HasErrors: "Хаталар бар",
    WithoutErrors: "Хатасыз башкарылган",
    UpdateSavedTeacher: "Үзгәрешләрегез сакланган",
    UpdateSavedStudent: "Караламагыз сакланган",
    UpdateSubmitedTeacher: "Тикшерү нәтиҗәләре укучыга җибәрелгән",
    UpdateSubmitedStudent: "Төзәтмәләрегез укытучыга җибәрелгән",
    Checking: "Тикшерүдә",
    Done: "Үтәлгән",
    FixStudent: "Төзәтергә",
    FixTeacher: "Хаталар бар",
    CheckingTime: "тикшерү • {{time}}",
    DoneTime: "җибәрелгән • {{time}}",
    TeacherName: "Укытучы: {{name}}",
    StudentName: "Студент: {{name}}",
    AllStatuses: "Барлык статуслар",
    Checked: "Тикшерелгән",
    NewCheck: "Тикшерүдә",
    Processing: "Эшкәртелә",
    StudentSearch: "Студентны эзләү",
    TeacherSearch: "Укытучыны эзләү",
    EmptyList: "Әлегә яраклы биремнәр юк",
    TaskSubtitle: 'Бүлек "{{unit}}" • "{{part}}" • Күнегү "{{exercise}}"',
    GoToExercise: "Күнегүгә күчү",
  },
};

export default tt;
